module.exports = __webpack_public_path__ + "static/media/floral-design-like-a-butterfly-svgrepo-com.710cda5e.svg";